// extracted by mini-css-extract-plugin
export var active = "_77-a";
export var activeIndicator = "_77-9";
export var disabled = "_77-b";
export var fullWidth = "_77-2";
export var lg = "_77-7";
export var md = "_77-6";
export var redoButtonTabGroup = "_77-0";
export var sm = "_77-5";
export var tabButton = "_77-4";
export var tabButtonsContainer = "_77-1";
export var themeDestructive = "_77-d";
export var themeNormal = "_77-c";
export var themeSuccess = "_77-e";
export var xl = "_77-8";
export var xs = "_77-3";